require('./infoRow.scss');
// @ vendor
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// @ commons
const { formatText } = require('core/i18n').i18n;

import OKSelect from 'components/commons/OKSelect/OKSelect';

class InfoRow extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { tilte: props.tilte }
    }

    getOptionsAmount = (options, value) => {
      let option = options.filter( option => option.value === value)
      if(option.length === 0) return null
      option = option.shift()
      const amountsOption = option.amountsOption

      return (amountsOption && amountsOption.size ? amountsOption.toJSON() : null)
    }

    getDescription = (options, value) => {
      let option = options.filter( option => option.value === value)
      if(option.length === 0) return null
      option = option.shift()
      if( !option.amountsOption ) return null
      const description = formatText('securityKit-infoRowDesc1', [option.targetKitLabel])

      return description
    }

    render() {

        const { amount,onAmountChange, noBorder, onChange, options, selected } = this.props;
        const optionsAmount = this.getOptionsAmount(options, selected)
        const amountValue = (amount && amount[0] !== undefined ? amount[0] : 0)
        const description = this.getDescription(options, selected)

        const titleClassName = classNames('info-row__title', {
            'info-row__no-desc': !description,
            'info-row__desc': description
        });
        const infoRowClassName = classNames('info-row', 'row', {
            'info-row__no-border': noBorder
        });

        return (
            <div className={infoRowClassName} >
                <div className="info-text__title col-sm-8">
                    <div className={titleClassName}>
                        <span className="info-row__title__initial">{this.state.tilte.initial}</span>
                        <span className="info-row__title__parenthesis">{this.state.tilte.parenthesis}</span>
                    </div>
                    {description &&
                        <div className="info-row__description">
                            <span>{description}</span>
                        </div>
                    }
                </div>
                <div className="info-row__options col-sm-4">
                    <OKSelect
                        name="info-row-select"
                        onChange={onChange}
                        value={selected}
                        options={options}
                        searchable={false}
                        clearable={false}
                    />
                    {optionsAmount &&
                        <div className="info-row__amount">
                            <OKSelect
                                name="info-row-select"
                                onChange={onAmountChange}
                                value={amountValue}
                                options={optionsAmount}
                                searchable={false}
                                clearable={false}
                          />
                        </div>
                    }
                </div>
            </div>
        );
    }
}

InfoRow.propTypes = {
    amount: PropTypes.array,
    onAmountChange: PropTypes.func.isRequired,
    noBorder: PropTypes.bool.isRequired,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    selected: PropTypes.string.isRequired,
    tilte: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ]),
};

export default InfoRow;
